export const setResult = (results: any) => ({
    type: 'SET_RESULT',
    payload: results,
  });
  